<template>
	<div class="select" :class="{readonly:readonly,disabled:disabled}" >
		<template v-if="!disabled && !readonly && !renderCell">
			<el-cascader v-if="cascader" :props="{ checkStrictly: checkStrictly ,multiple:multiple}"
				v-model="selectvalue" :size="size" :options="options" :placeholder="placeholder" :disabled="disabled"
				:collapse-tags="collapseTags" :clearable="clearable" filterable :show-all-levels="showAllLevels" @change="change">
				<template slot-scope="{ node, data }">
					<span>{{ data.label }}</span>
					<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
					<span v-if="node.isLeaf && data.alias">
						<el-tag size="mini" style="margin-left: 10px;">{{ data.alias }}</el-tag>
					</span>
				</template>
			</el-cascader>

			<el-checkbox-group v-else-if="checkbox" @change="change" v-model="selectvalue" :size="size" :disabled="disabled"
				:clearable="clearable">
				<el-checkbox v-for="item in options" :key="item.value" :label="item.value">
					{{item.label}}
				</el-checkbox>
			</el-checkbox-group>
				
			<el-select v-else :collapseTags="collapseTags" :multiple="multiple" :disabled="disabled" :size="size"
				v-model="selectvalue" @change="change" :allow-create="allowCreate" filterable placeholder="" :clearable="clearable"
				collapse-tags>
				<template v-if="!optionsFromRow">
					
					<template v-if="optionsGroup">
						<el-option-group v-for="(group,index) in options" :key="index" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"
								:disabled="item.disabled?item.disabled:false">
							</el-option>
						</el-option-group>
					</template>
					<template v-else>
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
							:disabled="item.disabled?item.disabled:false">
						</el-option>
					</template>

				</template>
				<template v-else>
					<template v-if="optionsGroup">
						<el-option-group v-for="(group,index) in row.selectoption?row.selectoption:[]" :key="index" :label="group.label">
							<el-option v-for="item in group.options" :key="item.value"
								:label="item.label" :value="item.value" :disabled="item.disabled?item.disabled:false">
							</el-option>
						</el-option-group>
					</template>
					<template v-else>
						<el-option v-for="item in row.selectoption?row.selectoption:[]" :key="item.value"
							:label="item.label" :value="item.value" :disabled="item.disabled?item.disabled:false">
						</el-option>
					</template>
					

					
				</template>
			</el-select>
			
			
			
		</template>
		<template v-else>
			<span v-if="renderCell">{{valuetext}}</span>
			<el-input v-else v-model="valuetext" :disabled="disabled" :readonly="readonly" :size="size"></el-input>
		</template>
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			value: {
				default: () => {
					return ''
				}
			},
			optionsGroup: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			optionsFromRow: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			cascader: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			checkStrictly: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			showAllLevels: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			checkbox: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			clearable: {
				type: Boolean,
				default: () => {
					return true
				}
			},
			
			
		},
		data() {
			return {
				demo:[],
				options: [],
				valuetext: '',
				selectvalue: this.value
			}
		},
		created() {
			//console.log(this.formCreateInject,this.selectoptions,1111111)
			if (this.formCreateInject) {
				this.options = this.formCreateInject.options
			} else {
				this.options = this.selectoptions
			}
			//console.log(this.options)
			this.options.forEach((item)=>{
				item.value = item.value?item.value.toString():null
			})
			this.transferValue(this.value)
			this.getValuetext(this.value)
			//console.log(this.valuetext,this.options,1444)

		},
		mounted() {

			// if (this.$slots.append) {
			// 	this.$refs.input.setAttribute('readonly', true)
			// }
			//console.log(this.$refs.input)
			// 	let i = document.createElement('i')
			// 	this.$refs.input.parentNode.appendChild(<i class="el-icon-delete"></i>)



		},
		watch: {
			value(value) {
				
				//console.log(typeof value,typeof value2,'value:'+value,'value2:'+value2)
				this.transferValue(value)
				this.getValuetext(value)
			},
			// renderCell() {
			// 	this.getValuetext(this.value)
			// },
			
			
			
			// selectvalue(e){
			// 	console.log(e)
			// },
			// selectvalue(e) {
			// 	if(typeof e === 'number'){
			// 		this.change(e.toString())
			// 	}else{
			// 		this.change(e)
			// 	}
			// },
			// disabled(val) {
			// 	if (this.$slots.append && val) {
			// 		this.hiddenAppend()
			// 	}
			// },
			readonly() {
				//console.log(this)
			}
		},
		computed: {

		},
		methods: {
			transferValue(value){
				let selectvalue = null
				if(Array.isArray(value)){
					selectvalue = value.map(String)
				}else if(typeof value === 'number'){
					selectvalue = value.toString()
				}else{
					selectvalue = value
				}
				if(!selectvalue){
					this.selectvalue = (this.checkbox || this.checkbox.multiple) ? [] :''
				}else{
					this.selectvalue = selectvalue
				}
			},
			getValuetext(value) {
				if(!value){
					return
				}
				value = Array.isArray(value) ? value : [value]
				// console.log(value,666)
				let valuetext = []
				if (this.optionsFromRow) {
					this.options = this.row.selectoption ? this.row.selectoption : []
				}
		
				this.options.forEach((item) => {
					let exist = value.findIndex((_item)=>{
						return _item == item.value
					})
					if(exist!==-1){
						valuetext.push(item.label)
					}
				})
				if(valuetext.length){
					valuetext = valuetext.join('|', valuetext)					
				}else{
					valuetext = value.join('|', valuetext)
				}
				this.valuetext = valuetext

			
			},

			change(val) {
				//console.log(val)
				let value = val
				if(typeof val === 'number'){
					value = val.toString()
				}
				this.$emit('input', Object.hasOwn(value, 'value') ? value.value : value)
			},

		}
	}
</script>
<style scope>




</style>